module.exports = __webpack_public_path__ + "static/media/user.c9387628.svg";